import React from 'react';
import { connect } from 'react-redux';

import TextManagerAddSideBarComponent from './TextManagerAddSideBarComponent';

class TextManagerAddSideBarContainer extends React.Component {
  render() {
    return (
      <TextManagerAddSideBarComponent
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let hoofdstuk = state.hoofdstuk.byId[ownProps.match.params.hoofdstukId];
  let categories = {};
  if(hoofdstuk.isGeneric === "1" || hoofdstuk.pakketId === null){
    categories = state.textManager.categories
  } else {
    //Find appliccable categories
    Object.keys(state.textManager.categories).forEach(key => {
      let cat = state.textManager.categories[key];
        
      //if(cat.pakketGroepId === hoofdstuk.pakketId){
        categories[cat.id] = cat;
      //}
    })
  }
  return {
    categories: categories,
    texts: state.textManager.texts,
    catToTexts: state.textManager.catToTexts,
    pakketGroepen: state.pakketGroep.byId,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      addCategory: dispatch.textManager.addCategory,
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextManagerAddSideBarContainer);
